<router-outlet>
  <app-http-loader></app-http-loader>
  <div *ngIf="promptNewDashboardDetected" class="new-dashboard-detected bg-blue">
    {{ 'NewDashboard.Available' | translate }}&nbsp;<u class="new-dashboard-detected-click-here" (click)="reload()">{{
      'ClickHere' | translate
    }}</u
    >&nbsp;{{ 'NewDashboard.toReload' | translate }}
  </div>
</router-outlet>
